import { create } from "zustand";
import api from "./api";

// Gemeinsamer Admin-Zustand: Bestellungen (für Liste und Badge) und Druckerstatus.
// Wird im Admin-Layout alle 30 s aktualisiert.
const useAdminStore = create((set) => ({
    orders: [],
    ordersLoaded: false,
    printerPing: null,

    fetchOrders: async () => {
        try {
            const response = await api.get("/orders");
            set({ orders: response.data, ordersLoaded: true });
        } catch (error) {
            set({ ordersLoaded: true });
        }
    },

    removeOrder: (id) => set((state) => ({ orders: state.orders.filter((o) => o._id !== id) })),

    fetchPrinter: async () => {
        try {
            const response = await api.get("/settings/latestPrinterOnline");
            set({ printerPing: response.data && response.data.value });
        } catch (error) {
            set({ printerPing: null });
        }
    },
}));

export default useAdminStore;
